import {
  IPagination,
  Maybe,
  QueryType,
  SearchEntityType,
} from '../../../utils/apollo/graphqlSchema';
import { ISearchInput, SearchableEntityTypes } from './types';

export const SEARCH_COUNT = 10;
export const SEARCH_MENU_FILTERS_WIDTH = 301;
export const SEARCH_MENU_WIDTH = 755;
export const SEARCH_MENU_HEIGHT = 465;

export const defaultPagination: IPagination = { first: SEARCH_COUNT, after: 0 };

export const defaultSearchInput: ISearchInput = {
  term: '',
  types: [],
  schemaIds: [],
  categoryIds: [],
  editorIds: [],
  queryTypes: [],
  isDisabled: false,
  failedReports: false,
  lastUpdateDateRange: null,
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  pagination: defaultPagination,
  favoriteOnly: false,
  activeSchemas: true,
};

export const tabList: (SearchableEntityTypes | null)[] = [
  null,
  SearchEntityType.Dashboard,
  SearchEntityType.Analysis,
  SearchEntityType.Cohort,
  SearchEntityType.Measure,
];

export const getTabNameByEntitySearchType = (type: Maybe<SearchEntityType>) => {
  switch (type) {
    case SearchEntityType.Dashboard:
      return 'Dashboards';
    case SearchEntityType.Analysis:
      return 'Reports';
    case SearchEntityType.Cohort:
      return 'Cohorts';
    case SearchEntityType.Measure:
      return 'Measures';
    case SearchEntityType.VirtualEvent:
      return 'Virtual Events';
    case SearchEntityType.Filter:
      return 'Filters';
    case SearchEntityType.BucketDef:
      return 'Binning';
    default:
      return 'All';
  }
};

export const universalSearchSupportedQueryTypes = [
  QueryType.Expression,
  QueryType.Funnel,
  QueryType.Path,
  QueryType.Retention,
  QueryType.Prediction,
  QueryType.DataTable,
  QueryType.CohortSample,
  QueryType.Significance,
];
